import { useEffect, useState } from "react";

import { chatApiInstance } from "../apis/chatApi";
import type { TicketChatAutomationMode } from "../utils/ticketChatMode";

/**
 * The agent a ticket thread's Auto Resolver run belongs to, or null.
 *
 * The poller may have started the run as a specialist agent, so the mode selector cannot assume the
 * default. Read again whenever the thread or its mode changes; a run a technician just started reads
 * as the agent they picked. Any failure is null, which the selector shows as the default agent.
 */
export function useThreadAgentId(threadId: string | null | undefined, capacity: TicketChatAutomationMode | null): number | null {
  const threadKey = threadId ? String(threadId) : null;
  const [loaded, setLoaded] = useState<{ threadKey: string; agentId: number | null } | null>(null);

  useEffect(() => {
    if (!threadKey || capacity !== 3) return undefined;
    let cancelled = false;
    chatApiInstance
      .getThreadAutomation(threadKey)
      .then((response) => {
        if (!cancelled) setLoaded({ threadKey, agentId: response?.agent_id || null });
      })
      .catch(() => {
        if (!cancelled) setLoaded({ threadKey, agentId: null });
      });
    return () => {
      cancelled = true;
    };
  }, [threadKey, capacity]);

  if (capacity !== 3 || !loaded || loaded.threadKey !== threadKey) return null;
  return loaded.agentId;
}
